import config from 'config/config';
import {trackEvent} from 'src/utils/analytics';

let fbLoginStatus = {};
let fbIsInit = false;

export const init = () => {
  return new Promise((resolve) => {
    if (fbIsInit) {
      resolve();
      return;
    }
    var fjs = document.getElementsByTagName('script')[0];
    var js = document.createElement('script');
    js.src = '//connect.facebook.net/en_US/sdk.js';
    fjs.parentNode.insertBefore(js, fjs);

    window.fbAsyncInit = () => {
      if (FB) {
        FB.init({
          appId: config.fb.appId,
          xfbml: true,
          version: 'v2.9',
        });
      }
      fbIsInit = true;
      resolve();
    };
  });
};

export const initFacebookSignup = (fbReady = () => {}) => {
  init().then(() => {
    FB.getLoginStatus(loginStatus => {
      // could do both of these things in an action... something to ponder
      fbReady();
      fbLoginStatus = loginStatus;
    });
  });
};

export const facebookSignupClick = (validateLoginData = () => {}) => {
  trackLoginClick();
  if (fbLoginStatus.status === 'connected') {
    handleLogin(fbLoginStatus, validateLoginData);
  } else {
    // Ask FB to authenticate the user
    FB.login((loginStatusNew) => {
      handleLogin(loginStatusNew, validateLoginData);
    }, {
      scope: config.fb.scope,
    });
  }
};

export const onFacebookShareClick = () => {
  const options = {
    method: 'share',
    href: `https://healthunlocked.com${window.location.pathname}`,
  };
  if ('ontouchstart' in window) {
    options.display = 'touch';
  }
  FB.ui(options);
};

const handleLogin = (response, validateLoginData) => {
  if (response.status === 'connected') {
    FB.api('/me?fields=email,name,gender,birthday,verified', userInfo => generateAuthDataAndLoginWithFB(response.authResponse, userInfo, validateLoginData));
  }
};

const generateAuthDataAndLoginWithFB = (auth, userInfo, validateLoginData) => {
  const isVerified = true;
  const fbLoginData = {
    accessToken: auth.accessToken,
    facebookUserId: auth.userID,
    staySignedIn: true,
    email: userInfo.email,
    isVerified,
  };
  validateLoginData(fbLoginData);
};

//get rid of this (probably)
const trackLoginClick = () => {
  const label = '';//this.app.res.controller + ' ' + this.app.res.action + ' ' + 'popup';
  trackEvent('Account', 'Clicked Facebook login button', label);
  // Track context
  // var signupTrackContext = this.props.isSignupModal
  //   ? this.ctx.getSignupContext()
  //   : this.props.signupContext;
  // Backbone.trigger('interaction:updateSignupContext', signupTrackContext);
};



// WEBPACK FOOTER //
// ./src/utils/facebook.js